module.exports = __webpack_public_path__ + "img/giri-pro.703a44bd.jpg";